// extracted by mini-css-extract-plugin
export default {"heading":"AllocationModal_heading__-qMQo","form":"AllocationModal_form__bj8tt"};